/**
 * Helper para obtener el companyId del localStorage
 * @returns {number|null} El ID de la empresa seleccionada o null si no hay ninguna
 */
export const getCompanyId = () => {
  const companyId = localStorage.getItem('selectedCompanyId');
  if (!companyId) {
    return null;
  }
  const parsed = parseInt(companyId, 10);
  return Number.isNaN(parsed) || parsed <= 0 ? null : parsed;
};

